<ion-content>
  <section>
    <div>
      <h3 class="edit-amount-title">
        {{ 'i18n.payments.editAmount.title' | translate }}
      </h3>
      <app-edit-payment-amount-input
        [disabled]="transactionDetails.status === Status.UNUSED"
        [maxVal]="transactionDetails.amountDue"
        [paymentAmount]="newAmount"
        [isTouch]="true"
        (updatePaymentAmountEmitter)="newAmount = $event.paymentAmount"
      ></app-edit-payment-amount-input>
    </div>

    <ion-grid>
      <h6 data-cy="transaction-details-title">
        {{ 'i18n.payments.editAmount.transactionDetails' | translate }}:
      </h6>
      <h4 data-cy="transaction-customer-info">
        {{ transactionDetails.customerName | titlecase }} #{{
          transactionDetails.customerNumber
        }}
      </h4>

      <ng-container
        *ngIf="
          transactionDetails?.hasSecondaryTransaction;
          else noSecondaryTransaction
        "
      >
        <ion-row>
          <ion-col>
            <span data-cy="transaction-type-label">
              {{ transactionDetails?.transactionTypeString }} #:
            </span>

            <span data-cy="transaction-type-value">
              {{ transactionDetails?.secondaryTransactionNumber }}
            </span>
          </ion-col>
        </ion-row>
        <ng-template
          [ngIf]="
            (!transactionDetails?.isr ||
              transactionDetails?.hasSecondaryTransaction) &&
            transactionDetails?.transactionNumber !== '0'
          "
        >
          <ion-row>
            <ion-col>
              <span data-cy="transaction-secondary-type-label">
                {{ 'i18n.payments.transactionRow.invoice' | translate }} #
              </span>
              <span data-cy="transaction-secondary-type-value">
                {{ transactionDetails?.transactionNumber }}
              </span>
            </ion-col>
          </ion-row>
        </ng-template>
      </ng-container>
      <ng-template #noSecondaryTransaction>
        <ion-row>
          <ion-col>
            <span data-cy="transaction-details-type-label">
              {{ transactionDetails?.transactionTypeString }} #:
            </span>
            <span data-cy="transaction-details-type-value">
              {{ transactionDetails?.transactionNumber }}
            </span>
          </ion-col>
        </ion-row>
      </ng-template>

      <ion-row>
        <ion-col>
          <span data-cy="transaction-purchase-order-label">
            {{ 'i18n.payments.transactionRow.purchaseOrder' | translate }}
            #</span
          >
          <span data-cy="transaction-purchase-order-value">{{
            transactionDetails.customerPO
          }}</span>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <span data-cy="transaction-due-date-label">
            {{ 'i18n.payments.transactionRow.dueDate' | translate }}</span
          >
          <span data-cy="transaction-due-date-value">{{
            transactionDetails.dueDate | date: 'MM/d/yyyy':'GMT'
          }}</span>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <span data-cy="transaction-status-label">
            {{ 'i18n.payments.transactionRow.status' | translate }}</span
          >
          <span data-cy="transaction-status-value">{{
            transactionDetails.statusString
          }}</span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <span data-cy="transaction-total-due-label">
            {{ 'i18n.payments.transactionRow.totalDue' | translate }}</span
          >
          <span data-cy="transaction-total-due-value">{{
            transactionDetails.amountDue | currency
          }}</span>
        </ion-col>
      </ion-row>
    </ion-grid>
  </section>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-modal-button"
        class="usf-outline-green-mobile-modal-button"
        (click)="closeModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="save-modal-button"
        class="usf-fill-green-mobile-modal-button"
        (click)="submitEditAmountModal()"
      >
        {{ 'i18n.common.apply' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
